import React from "react";
import MUITable from "Components/UI/Tables/MUITable";

const getUserNameById = (users, userId) => {
  const foundObject = users.find((usr) => usr.Id === userId);
  return foundObject ? foundObject.Username : "";
};

const createTableRows = (logs, users) => {
  return logs?.map((c) => {
    return [
      c.Id,
      c.CreateTime,
      getUserNameById(users, c.AppUserId),
      c.EntityType,
      c.EntityId,
      c.UserAction,
      c.Message,
      c.RequestUrl,
      c.RequestBody,
      c.Response,
    ];
  });
};

export default function SystemTable({ logs, users }) {
  const rows = createTableRows(logs, users);

  const columns = [
    {
      name: "ID",
      options: {
        filter: false,
      },
    },
    {
      name: "Skapad",
      options: {
        filter: false,
      },
    },
    {
      name: "Användare",
    },
    {
      name: "Entitetstyp",
    },
    {
      name: "Entitets ID",
      options: {
        filter: false,
      },
    },

    {
      name: "Användaråtgärd",
      options: {
        filter: false,
      },
    },

    {
      name: "Meddelande",
      options: {
        filter: false,
      },
    },
    {
      name: "URL",
      options: {
        filter: false,
      },
    },
    {
      name: "Input",
      options: {
        filter: false,
        display: false,
      },
    },
    {
      name: "Resultat",
      options: {
        filter: false,
        display: false,
      },
    },
  ];

  const options = {
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    filterType: "dropdown",
    responsive: "standard",
    viewColumns: true,
    downloadOptions: {
      separator: ";",
      filename: "all_systems.csv",
    },
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 30, 100],
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  return (
    <MUITable options={options} title={""} data={rows} columns={columns} />
  );
}
